import Button from "components/Button";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const PersonalDetailsWrapper = styled.div`
    margin: 0 24px;
    background-color: #fff;
    padding: 18px 24px;
    border-radius: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledHeading = styled(Text)`
    @media (${theme.breakpoints.mobileL}) {
        font-size: 16px;
    }
`;

export const ButtonContainer = styled.div`
    align-self: flex-start;
    margin-top: 1.5rem;
    display: flex;
    gap: 10px;

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 0;
    }
`;

export const CircularButton = styled(Button)`
    height: 42px;
    width: 42px;
`;
